import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import SupportModal from "./pages/SupportModal";

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-links">
        <div className="footer-link-wrapper">
          <div className="footer-link-items">
            <h2>About Us</h2>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/">Careers</Link>
            {/* <Link to="/">Investors</Link>
            <Link to="/">Terms of Service</Link> */}
          </div>
          <div className="footer-link-items">
            <h2>Contact Us</h2>
            <Link to="/contact">Contact</Link> 
            {/* <Link to="/">Support</Link> */}
            <SupportModal />
          </div>
        </div>
        <div className="footer-link-wrapper">
          <div className="footer-link-items">
            <h2>Follow Us</h2>
            <a href="https://www.instagram.com/priceperfect.app/" target="_blank" rel="noopener noreferrer">Instagram</a>
          </div>
        </div>
      </div>

      <section className="social-media">
        <div className="social-media-wrap">
          <div className="footer-logo">
            <Link to="/" className="navbar-logo">
              PRICE PERFECT 
            </Link>
          </div>
          <small className="website-rights">PricePerfect © 2025</small>
          <div className="social-icons">
            <a className="social-icon-link instagram" href="https://www.instagram.com/priceperfect.app/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
